import api from '../../utils/api';
import { DiagnosticCenterResponse } from '../../models/MasterAdmin/diagnosticCenter';
import { LabTestBookingResponse } from '../../models/MasterAdmin/labTestBooking';

export const fetchDiagnosticCenterProfile = async (vendorId: string): Promise<DiagnosticCenterResponse> => {
  try {
    const response = await api.get(`/master-admin/diagnostic-center/${vendorId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching diagnostic center profile:', error);
    throw error;
  }
};

export const fetchLabTestBookings = async (vendorId: string): Promise<LabTestBookingResponse> => {
  try {
    const response = await api.get(`/master-admin/lab-bookings/${vendorId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching lab test bookings:', error);
    throw error;
  }
}; 